import { render, staticRenderFns } from "./Breakpoints.vue?vue&type=template&id=34212c16&scoped=true"
import script from "./Breakpoints.vue?vue&type=script&lang=ts"
export * from "./Breakpoints.vue?vue&type=script&lang=ts"
import style0 from "./Breakpoints.vue?vue&type=style&index=0&id=34212c16&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34212c16",
  null
  
)

export default component.exports